import { render, staticRenderFns } from "./OneTimeOrders.vue?vue&type=template&id=0c33d53f"
import script from "./OneTimeOrders.vue?vue&type=script&lang=js"
export * from "./OneTimeOrders.vue?vue&type=script&lang=js"
import style0 from "./OneTimeOrders.vue?vue&type=style&index=0&id=0c33d53f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports